export const scrollToOffer = (e?: React.MouseEvent) => {
  if (e) e.preventDefault()
  const offerSection = document.getElementById('offer')
  if (offerSection) {
    offerSection.scrollIntoView({ behavior: 'smooth' })
  }
}
